'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$() {
  this.aOr = null;
  this.aOI = null;
  this.aOu = null;
  this.aOv = false;
  this.aOA = null;
  this.aOB = false;
  this.aOG = null;
  this.aOH = false;
  this.aOs = null;
  this.aOt = false;
  this.aOE = null;
  this.aOF = false;
  this.aOC = null;
  this.aOD = false;
  this.aOw = null;
  this.aOx = false;
  this.aOy = null;
  this.aOz = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ = this;
  this.aOr = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$();
  this.aOI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$.prototype = $p;
$p.eR = (function() {
  return this.aOr;
});
$p.eO = (function() {
  return this.aOI;
});
$p.bW = (function() {
  if ((!this.aOv)) {
    this.aOu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aOv = true;
  }
  return this.aOu;
});
$p.b9 = (function() {
  if ((!this.aOB)) {
    this.aOA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aOB = true;
  }
  return this.aOA;
});
$p.b3 = (function() {
  if ((!this.aOH)) {
    this.aOG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aOH = true;
  }
  return this.aOG;
});
$p.aG = (function() {
  if ((!this.aOt)) {
    this.aOs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aOt = true;
  }
  return this.aOs;
});
$p.az = (function() {
  if ((!this.aOF)) {
    this.aOE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aOF = true;
  }
  return this.aOE;
});
$p.aY = (function() {
  if ((!this.aOD)) {
    this.aOC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aOD = true;
  }
  return this.aOC;
});
$p.sX = (function() {
  if ((!this.aOx)) {
    this.aOw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Place of Delivery";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aOx = true;
  }
  return this.aOw;
});
$p.afp = (function() {
  if ((!this.aOz)) {
    this.aOy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aOz = true;
  }
  return this.aOy;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$, "app.data.data_point_types$package$PlaceOfDeliveryForm$", ({
  Gf: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$() {
  this.aOp = null;
  this.aOq = false;
  this.aOn = null;
  this.aOo = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$.prototype = $p;
$p.aA = (function() {
  if ((!this.aOq)) {
    this.aOp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aOq = true;
  }
  return this.aOp;
});
$p.afh = (function() {
  if ((!this.aOo)) {
    this.aOn = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$().sX();
    this.aOo = true;
  }
  return this.aOn;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$, "app.data.data_point_types$package$PlaceOfDelivery$", ({
  Ge: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDelivery$ };
//# sourceMappingURL=app.data.data_point_types$package$-Place-Of-Delivery$.js.map
